import styled from "@emotion/styled";
import { TABLET_QUERY_MAX_WIDTH } from "constants/vp-sizes";
import { TOP_LAYER } from "constants/z-index";
import colors from "styles/colors";
export const StyledDesktopContentComponent = styled.div`
  height: 100%;
  display: flex;
  align-items: center;

  .text-part-wrapper {
    width: 50vw;
    display: flex;
    align-items: center;
    padding: 16px 0 16px 80px;
  }

  .asset-part-wrapper {
    width: 50vw;
    height: 100vh;
    top: 0;
    right: 0;
    overflow: hidden;
    position: fixed;

    .intro-video-button-wrapper {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      z-index: ${TOP_LAYER};
      display: flex;
      align-items: center;
      justify-content: center;

      .intro-video-button {
        cursor: pointer;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;

        &:hover {
          .intro-video-button-image {
            transform: scale(1.1);
          }
        }

        .intro-video-button-image {
          margin-top: 10vh;
          width: 20vh;
          transition: transform 0.1s ease-in-out;
        }

        .intro-video-button-text {
          color: ${colors["white"]};
          background-color: ${colors["black"]};
          padding: 12px 24px;
          border-radius: 10px;
          margin-top: 32px;
          font-size: 3vh;
          outline: none;
        }
      }
    }
  }

  @media (max-width: ${TABLET_QUERY_MAX_WIDTH}) {
    .text-part-wrapper {
      padding: 16px 0 16px 54px;
    }
  }
`;
